<app-layout>
    <admin-reports-tab :referrer="filters.referrer" section="withdrawals"></admin-reports-tab>
    <h1 class="mt-10 mb-8 font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.users.edit', filters.referrer)" v-if="filters.referrer">Go Back - </inertia-link> Withdrawals
    </h1>
    <div class="mb-6 flex justify-between items-center">
        <search-filter v-model="form.search" class="w-full max-w-md mr-4 focus:outline-none" @reset="reset">
            <label class="block text-gray-700">Type:</label>
            <select v-model="form.type" class="mt-1 w-full form-select rounded">
                <option :value="null" />
                <option value="coin">Coin</option>
                <option value="fiat">Fiat</option>
            </select>
        </search-filter>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
            <tr class="text-left font-bold">
                <th class="px-3 pt-6 pb-4">Status</th>
                <th class="px-3 pt-6 pb-4">ID</th>
                <th class="px-3 pt-6 pb-4">TXN</th>
                <th class="px-3 pt-6 pb-4">Amount</th>
                <th class="px-3 pt-6 pb-4">Address</th>
                <th class="px-3 pt-6 pb-4">PaymentID</th>
                <th class="px-3 pt-6 pb-4">Network</th>
                <th class="px-3 pt-6 pb-4">UserID</th>
                <th class="px-3 pt-6 pb-4">System Wallet Balance</th>
                <th class="px-3 pt-6 pb-4">Actions</th>
            </tr>
            <tr v-for="withdrawal in withdrawals.data" :key="withdrawal.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center focus:text-indigo-500">
                        <badge v-if="withdrawal.status == 'waiting_approval'" class="mr-2" type="orange">
                            {{  'Pending' }}
                        </badge>
                        <badge v-if="withdrawal.status == 'confirmed_system'" class="mr-2" type="orange">
                            {{  'System Confirmed' }}
                        </badge>
                        <badge v-if="withdrawal.status == 'waiting_provider_approval'" class="mr-2" type="orange">
                            {{  'Provider Approval' }}
                        </badge>
                        <badge v-if="withdrawal.status == 'confirmed_provider'" class="mr-2" type="green">
                            {{  'Provider Confirmed' }}
                        </badge>
                        <badge v-if="withdrawal.status == 'rejected'" class="mr-2" type="red">
                            {{  'Rejected' }}
                            <t-dropdown
                                variant="tooltip"
                                toggle-on-hover
                            >
                              <span
                                  slot="trigger"
                                  class="text-white"
                              >
                                <font-awesome-icon icon="info-circle" class="ml-1" />
                              </span>

                              <template>
                                  <div class="p-5 text-red-500" v-html="withdrawal.rejected_reason"></div>
                              </template>
                            </t-dropdown>
                        </badge>
                        <badge v-if="withdrawal.status == 'failed'" class="mr-2" type="red">
                            {{  'Failed' }}
                        </badge>
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        <template v-if="withdrawal.source_id == 'system'">
                            <badge class="mr-2" type="red">
                                {{  'Cold Storage' }}
                            </badge>
                        </template>
                        <template v-else>
                        
                        
                        	<a v-if="withdrawal.network.slug == 'erc20' || withdrawal.network.slug == 'eth'" class="text-indigo-500" target="_blank" :href="'https://etherscan.io/tx/' + withdrawal.txn">{{ format_string(withdrawal.withdrawal_id, 10) }}</a>
                        <a v-else-if="withdrawal.network.slug == 'bep20' || withdrawal.network.slug == 'bnb'" class="text-indigo-500" target="_blank" :href="'https://bscscan.com/tx/' + withdrawal.txn">{{ format_string(withdrawal.withdrawal_id, 10) }}</a>
                        <a v-else class="text-indigo-500" target="_blank" :href="withdrawal.txn_link">{{ format_string(withdrawal.withdrawal_id, 10) }}</a>
                        	
                        
                            <font-awesome-icon v-if="withdrawal.withdrawal_id" class="text-gray-600 ml-2 cursor-pointer" icon="copy" @click="doCopy(withdrawal.withdrawal_id)" />
                        </template>
                    </span>
                </td>
                <td class="border-t">
                    <span v-if="withdrawal.txn && withdrawal.txn_link" class="px-6 py-4 flex items-center">
                    
                    
                    <a v-if="withdrawal.network.slug == 'erc20' || withdrawal.network.slug == 'eth'" class="text-indigo-500" target="_blank" :href="'https://etherscan.io/tx/' + withdrawal.txn">{{ format_string(withdrawal.txn, 10) }}</a>
                        <a v-else-if="withdrawal.network.slug == 'bep20' || withdrawal.network.slug == 'bnb'" class="text-indigo-500" target="_blank" :href="'https://bscscan.com/tx/' + withdrawal.txn">{{ format_string(withdrawal.txn, 10) }}</a>
                        <a v-else class="text-indigo-500" target="_blank" :href="withdrawal.txn_link">{{ format_string(withdrawal.txn, 10) }}</a>
                        	
                    
                        
                        
                        <font-awesome-icon v-if="withdrawal.txn" class="text-gray-600 ml-2 cursor-pointer" icon="copy" @click="doCopy(withdrawal.txn)" />
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ withdrawal.amount }} {{ withdrawal.currency.symbol }}
                    </span>
                </td>
                <td class="border-t">
                    <div class="px-3 py-2 flex items-center">
                        {{ format_string(withdrawal.address, 10) }}
                        <font-awesome-icon v-if="withdrawal.address" class="ml-2 cursor-pointer" icon="copy" @click="doCopy(withdrawal.address)" />
                    </div>
                </td>
                <td class="border-t">
                    <div class="px-3 py-2 flex items-center">
                        {{ format_string(withdrawal.payment_id, 5) }}
                        <font-awesome-icon v-if="withdrawal.payment_id" class="ml-2 cursor-pointer" icon="copy" @click="doCopy(withdrawal.payment_id)" />
                    </div>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ withdrawal.network.name }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ withdrawal.user.id }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ parseFloat(withdrawal.currency.wallet_balance) + parseFloat(withdrawal.currency.wallet_balance_erc) + parseFloat(withdrawal.currency.wallet_balance_trc) + parseFloat(withdrawal.currency.wallet_balance_bep)  }} {{ withdrawal.currency.symbol }}
                    </span>
                </td>
                <td class="border-t">
                    <span v-if="withdrawal.status == 'waiting_approval'" class="px-3 py-2 flex items-center focus:text-indigo-500">
                        <template v-if="parseFloat(parseFloat(withdrawal.currency.wallet_balance) + parseFloat(withdrawal.currency.wallet_balance_erc) + parseFloat(withdrawal.currency.wallet_balance_trc) + parseFloat(withdrawal.currency.wallet_balance_bep)) >= parseFloat(withdrawal.amount)">
                            <t-button-green @click="approve(withdrawal)" class="mr-2">Approve</t-button-green>
                            <t-button-red @click="reject(withdrawal)">Reject</t-button-red>
                        </template>
                        <template v-else>
                            <badge class="mr-2" type="red">
                                {{  'Insufficient funds' }}
                            </badge>
                            <t-button-red class="ml-2" @click="reject(withdrawal)">Reject</t-button-red>
                        </template>
                    </span>
                </td>
            </tr>
            <tr v-if="withdrawals.data.length === 0">
                <td class="border-t px-6 py-2" colspan="100">No withdrawals found.</td>
            </tr>
        </table>
    </div>
    <pagination :links="withdrawals.links" />

    <!-- Show Rejection Reason Modal -->
    <jet-dialog-modal :show="showReasonModal" @close="closeReasonModal">
        <template #title>
            Rejected Reason
        </template>

        <template #content>
            <div v-html="rejectedReason"></div>
        </template>

        <template #footer>
            <jet-secondary-button @click.native="closeReasonModal">
                Close
            </jet-secondary-button>
        </template>
    </jet-dialog-modal>

    <!-- Confirmation Modal -->
    <jet-confirmation-modal :show="withdrawalBeingReviewed">
        <template #title>
            Confirmation modal
        </template>

        <template #content>
            <div v-if="selectedAction == 'approve'">Are you sure you would like to {{ selectedAction }} the withdrawal request?</div>

            <div v-if="selectedAction == 'reject'" class="flex flex-wrap">
                Please write down the rejection reason
                <t-textarea v-model="rejectedReasonText" class="mt-5 w-full"></t-textarea>
            </div>
        </template>

        <template #footer>
            <jet-secondary-button @click.native="withdrawalBeingReviewed = null">
                Nevermind
            </jet-secondary-button>

            <jet-danger-button class="ml-2" @click.native="confirmAction">
                {{ selectedAction }}
            </jet-danger-button>
        </template>
    </jet-confirmation-modal>

</app-layout>
